import { Link } from "react-router-dom";
import { site } from "@/mocks/site";
import { scoops } from "@/mocks/scoops";
import VerdictBadge from "@/components/base/VerdictBadge";
import CredibilityMeter from "@/components/base/CredibilityMeter";

export default function Hero() {
  const spotlight = scoops[0];

  return (
    <section className="relative isolate overflow-hidden">
      <div className="absolute inset-0" aria-hidden="true">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20documentary%20scene%20of%20dim%20archive%20room%20with%20rows%20of%20evidence%20folders%2C%20a%20magnifying%20glass%20and%20warm%20desk%20lamp%20glow%2C%20deep%20warm%20brown%20and%20crimson%20tones%2C%20cinematic%20low%20key%20lighting%2C%20investigative%20verification%20concept%2C%20no%20text&width=1600&height=900&seq=hero-archive-room&orientation=landscape"
          alt="档案室中排列整齐的证据文件夹与放大镜，象征逐条求证"
          title="拾真社 · 独家爆料求证档案室"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/92 via-foreground-950/80 to-foreground-950/55" aria-hidden="true"></div>

      <div className="relative mx-auto max-w-[1200px] px-4 py-16 md:px-8 md:py-24 lg:py-28">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[1.35fr_1fr] lg:items-center">
          <div className="animate-rise">
            <p className="inline-flex items-center gap-2 rounded-full border border-accent-500/40 bg-accent-500/10 px-3 py-1 font-label text-[11px] uppercase tracking-[0.18em] text-accent-400">
              <i className="ri-radar-line" aria-hidden="true"></i>
              独家爆料 · 逐条求证
            </p>
            <h1 className="mt-6 font-heading text-3xl font-bold leading-[1.25] text-background-50 md:text-5xl">
              每一条爆料
              <br className="hidden sm:block" />
              都该有可追溯的<span className="text-accent-400">来源</span>与<span className="text-accent-400">证据</span>
            </h1>
            <p className="mt-6 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
              拾真社把零散的爆料整理成一份份档案：原始材料、来源链、可信度评分与真假对照，全部摊开在一页里。
              不盲目跟风，只摆事实讲依据，帮你判断事件的真实可信度。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/scoops"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
              >
                <i className="ri-folder-open-line" aria-hidden="true"></i>
                浏览爆料库
              </Link>
              <Link
                to="/verify"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-background-50/30 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 whitespace-nowrap"
              >
                <i className="ri-question-answer-line" aria-hidden="true"></i>
                了解求证方法
              </Link>
            </div>

            <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-background-50/15 pt-6">
              {site.stats.map((stat) => (
                <div key={stat.label}>
                  <dt className="font-label text-xl font-bold text-accent-400 md:text-2xl">{stat.value}</dt>
                  <dd className="mt-1 text-[11px] leading-snug text-background-300 md:text-xs">{stat.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <aside className="animate-rise rounded-lg border border-background-50/15 bg-background-50/8 p-5 backdrop-blur-md md:p-6">
            <div className="flex items-center justify-between">
              <p className="font-label text-[11px] uppercase tracking-[0.18em] text-accent-400">今日重点档案</p>
              <span className="flex h-6 w-6 items-center justify-center rounded-md bg-accent-500/20 text-accent-400">
                <i className="ri-flashlight-line" aria-hidden="true"></i>
              </span>
            </div>
            <Link to={`/scoop/${spotlight.id}`} className="mt-4 block">
              <div className="flex flex-wrap items-center gap-2">
                <VerdictBadge verdict={spotlight.verdict} size="sm" />
                <span className="font-label text-[11px] text-background-300">{spotlight.code}</span>
              </div>
              <h2 className="mt-3 font-heading text-lg font-bold leading-snug text-background-50 transition-colors hover:text-accent-400">
                {spotlight.title}
              </h2>
            </Link>
            <div className="mt-5 [&_.font-label]:!text-background-300 [&_.text-foreground-950]:!text-background-50 [&_.text-foreground-400]:!text-background-400">
              <CredibilityMeter value={spotlight.credibility} />
            </div>
            <div className="mt-5 flex items-center justify-between border-t border-background-50/15 pt-4 font-label text-[11px] text-background-300">
              <span className="whitespace-nowrap"><i className="ri-links-line mr-1"></i>{spotlight.sources} 个来源</span>
              <span className="whitespace-nowrap">更新 {spotlight.updated.slice(5, 10)}</span>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}